"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.STATUSES = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = require("react");
var _reactModal = _interopRequireDefault(require("react-modal"));
var _reactToastify = require("react-toastify");
var _init = _interopRequireDefault(require("../Context/i18n/init"));
var _DateTime = require("../Context/l10n/DateTime");
var _Units = require("../Context/l10n/Units");
var _Number = require("../Context/l10n/Number");
var _i18n = require("../Context/i18n");
var _app = require("../Context/app");
var _NotificationModule = _interopRequireDefault(require("../Notification/Notification.module.scss"));
var _Loader = _interopRequireDefault(require("./Loader"));
var _g11n = _interopRequireDefault(require("./g11n"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["i18n", "build", "render", "promises", "rootElement"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const STATUSES = exports.STATUSES = {
  ERROR: 'error',
  LOADING: 'loading',
  INITIALIZED: 'initialized'
};
const NOTIFICATION_DEFAULTS = {
  autoClose: 8000,
  closeButton: false,
  closeOnClick: false,
  draggable: false,
  hideProgressBar: true,
  limit: 1,
  pauseOnFocusLoss: false,
  pauseOnHover: false
};
const Composed = _ref => {
  let {
    children,
    notification,
    loadingText
  } = _ref;
  const {
    selectedLang,
    selectedCountry
  } = (0, _i18n.useI18nContext)();
  const {
    date,
    units
  } = (0, _react.useMemo)(() => {
    const region = _g11n.default.find(_ref2 => {
      let {
        code
      } = _ref2;
      return code === selectedCountry;
    });
    return {
      units: region.units,
      date: _objectSpread(_objectSpread({}, region.languages.find(_ref3 => {
        let {
          code
        } = _ref3;
        return code === selectedLang;
      }).date), {}, {
        // enhance the date-fns locale object with the full language ISO code + country ISO code
        localeCode: selectedLang
      })
    };
  }, [selectedLang, selectedCountry]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateTime.L10nDateTimeProvider, {
    selected: date,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Units.L10nUnitsProvider, {
      selected: units,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Number.L10nNumberProvider, {
        selected: selectedLang,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_app.AppContextProvider, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Suspense, {
            fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
              loadingText: loadingText
            }),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _NotificationModule.default.notificationWrapper,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactToastify.ToastContainer, _objectSpread(_objectSpread(_objectSpread({}, NOTIFICATION_DEFAULTS), notification), {}, {
                className: _NotificationModule.default.notificationContainer,
                progressClassName: _NotificationModule.default.progress
              }))
            }), children]
          })
        })
      })
    })
  });
};
const App = _ref4 => {
  let {
      i18n,
      build,
      render,
      promises,
      rootElement
    } = _ref4,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  const [data, setData] = (0, _react.useState)(null);
  const [status, setStatus] = (0, _react.useState)(STATUSES.LOADING);
  const rendered = (0, _react.useMemo)(() => render({
    data,
    status
  }), [data, status, render]);
  (0, _react.useEffect)(() => {
    const getter = async () => {
      try {
        setData(await Promise.all([(0, _init.default)({
          build,
          options: i18n
        })].concat(promises)).then(resp => resp.slice(1)));
        setStatus(STATUSES.INITIALIZED);
      } catch (error) {
        setData(error);
        setStatus(STATUSES.ERROR);
      }
    };
    getter();
    _reactModal.default.setAppElement(rootElement);
    // only fire this one time, it's fine if the deps are stale
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  switch (status) {
    case STATUSES.LOADING:
      return rendered || /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
        loadingText: props.loadingText
      });
    case STATUSES.ERROR:
    case STATUSES.INITIALIZED:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.I18nProvider, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Composed, _objectSpread(_objectSpread({}, props), {}, {
          children: rendered
        }))
      });
  }
};
App.defaultProps = {
  i18n: {},
  promises: [],
  render: () => null,
  rootElement: '#root'
};
var _default = exports.default = App;